import React, { useState } from "react";

const SECTIONS = ["Pharmacy Knowledge", "Customer Handling", "Situational Questions"];

const EMPTY_HI = { question: "", options: [], answer: "" };

const EMPTY_QUESTION = {
  section: "Pharmacy Knowledge",
  type: "mcq",
  en: { question: "", options: ["", "", "", ""], answer: "" },
  hi: { ...EMPTY_HI, options: ["", "", "", ""] },
};

const AddQuestionModal = ({ t, onClose, onAdd }) => {
  const [draft, setDraft] = useState({
    ...EMPTY_QUESTION,
    en: { ...EMPTY_QUESTION.en, options: [...EMPTY_QUESTION.en.options] },
    hi: { ...EMPTY_QUESTION.hi, options: [...EMPTY_QUESTION.hi.options] },
  });
  const [error, setError] = useState("");

  const handleQChange = (field, value) => {
    setDraft({
      ...draft,
      en: { ...draft.en, [field]: value },
    });
    setError("");
  };

  const handleOptionChange = (optIndex, value) => {
    const updated = {
      ...draft,
      en: {
        ...draft.en,
        options: [...draft.en.options],
      },
    };
    const oldVal = updated.en.options[optIndex];
    updated.en.options[optIndex] = value;
    if (updated.en.answer === oldVal) {
      updated.en.answer = value;
    }
    setDraft(updated);
    setError("");
  };

  const handleTypeChange = (type) => {
    const updated = { ...draft, type };
    if (type === "text") {
      updated.en = { ...updated.en, options: [], answer: "" };
    } else if (updated.en.options.length === 0) {
      updated.en = { ...updated.en, options: ["", "", "", ""], answer: "" };
    }
    setDraft(updated);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!draft.en.question.trim()) {
      setError(t.questionRequired);
      return;
    }
    if (draft.type !== "text") {
      const filledOptions = draft.en.options.filter((o) => o.trim());
      if (filledOptions.length < 2) {
        setError(t.optionsRequired);
        return;
      }
      if (!draft.en.answer) {
        setError(t.correctAnswerRequired);
        return;
      }
    }
    onAdd({
      ...draft,
      hi: {
        question: "",
        options: draft.type === "text" ? [] : ["", "", "", ""],
        answer: "",
      },
    });
    onClose();
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal add-question-modal" onClick={(e) => e.stopPropagation()}>
        <div className="add-question-modal-header">
          <div>
            <h2>{t.addQuestion}</h2>
            <p>{t.addQuestionDesc}</p>
          </div>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="add-question-form">
          {error && <div className="admin-login-error">{error}</div>}

          <div className="question-type-row">
            <select value={draft.section} onChange={(e) => setDraft({ ...draft, section: e.target.value })}>
              {SECTIONS.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <select value={draft.type} onChange={(e) => handleTypeChange(e.target.value)}>
              <option value="mcq">{t.mcq}</option>
              <option value="text">{t.text}</option>
            </select>
          </div>

          <div className="admin-question-single">
            <input
              placeholder="Question"
              value={draft.en.question}
              onChange={(e) => handleQChange("question", e.target.value)}
              autoFocus
            />
            {draft.type !== "text" && draft.en.options.map((opt, oIdx) => (
              <div key={oIdx} className="option-edit-row">
                <span className="option-edit-label">{String.fromCharCode(65 + oIdx)}</span>
                <input
                  placeholder={`Option ${oIdx + 1}`}
                  value={opt}
                  onChange={(e) => handleOptionChange(oIdx, e.target.value)}
                />
              </div>
            ))}
            {draft.type !== "text" && (
              <div className="correct-answer-row">
                <label>{t.correctAnswer}</label>
                <select value={draft.en.answer} onChange={(e) => handleQChange("answer", e.target.value)}>
                  <option value="">{t.selectCorrect}</option>
                  {draft.en.options.map((opt, oIdx) => (
                    <option key={oIdx} value={opt}>{String.fromCharCode(65 + oIdx)}: {opt || "(empty)"}</option>
                  ))}
                </select>
              </div>
            )}
          </div>

          <div className="add-question-modal-actions">
            <button type="button" className="admin-btn admin-btn-outline" onClick={onClose}>
              {t.cancel}
            </button>
            <button type="submit" className="admin-btn admin-btn-primary">
              <span className="admin-btn-icon">＋</span>
              {t.addToList}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddQuestionModal;
